import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 84C06231-55E7-4450-B88D-964B33FCACDA
 * name bookmark-box-multiple
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-box-multiple.svg
 * tags
 */
export const BookmarkBoxMultipleIcon = createSvgIcon(<><path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 12L17.5 10.5L15 12V4H20V12Z" /></>, 'BookmarkBoxMultipleIcon');
export default BookmarkBoxMultipleIcon